<div class="ui  header top attached segment sd" style="background:#f9fafb">
    {{searchName}} Search:
    <span class="right floated">
          <span class="ui mini icon input" style="margin:5px" popupPlacement="top" popupText="Select search group operator">
            <select class="ui fluid dropdown" (change)="changeCondition($event)">
                <option *ngFor="let opt of groupOperators" [ngValue]="opt">{{opt.name}}</option>
            </select>
        </span>
        <span class="ui mini icon input" style="margin:5px">
            <select class="ui fluid dropdown" [formControl]="selectForm" (ngModelChange)="logSelected($event)">
                <option *ngFor="let opt of headers" [ngValue]="opt">{{opt.label}}</option>
            </select>
        </span>
        <span>
            <button class="ui blue button" (click)="add()">
                <i class="plus icon"></i>
            </button>
        </span>
    </span>
</div>
<div class="ui bottom attached  basic fill segment sd" style="margin-bottom: 27px!important">
    <div class="ui form">
        <div class="ui grid">
            <div class="column row" *ngFor="let field of  fieldx; let i =index; trackBy:trackByIndex">
                <div class="five wide column">
                    <div class="field">
                        <input type="text" [(ngModel)]="fieldx[i].label" disabled/>
                    </div>
                </div>
                <div class="three wide column">
                    <div class="field">
                        <select *ngIf="field.field !== 'oldContractorUsername'" class="ui fluid dropdown" [(ngModel)]="fieldx[i].op" type="text"
                          >
                            <option *ngFor="let opt of operators" [ngValue]="opt.id">{{opt.name}}</option>
                        </select>
                        <select disabled *ngIf="field.field === 'oldContractorUsername'" class="ui fluid dropdown" [(ngModel)]="fieldx[i].op" type="text"
                            >
                            <option *ngFor="let opt of oldoperators" [ngValue]="opt.id">{{opt.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="six wide column">
                    <app-search-number-filter *ngIf="field.type === 'integer'" [field]="fieldx[i]" [index]="i"></app-search-number-filter>
                    <app-search-text-filter *ngIf="field.type === 'text'" [field]="fieldx[i] " [index]="i"></app-search-text-filter>
                    <app-search-select-filter (query)="changeOperators($event)" *ngIf="field.type === 'select'" [field]="fieldx[i]" [index]="i"></app-search-select-filter>
                    <app-search-date-filter *ngIf="field.type === 'date'" [field]="fieldx[i] | dateTimeConverter" [index]="i"></app-search-date-filter>
                </div>
                <div class="one wide column">
                    <button class="ui red button" (click)="remove(i)">
                        <i class="minus icon"></i>
                    </button>
                </div>
            </div>

            <div class="column row">
                <div class="column">
                    <button class="ui button" (click)="cancel()">Cancel</button>
                    <button class="ui blue button" (click)="submit()">Search</button>
                </div>
            </div>

        </div>


    </div>

</div>